import {
	Instance,
	SnapshotIn,
	applySnapshot,
	flow,
	getParent,
	getSnapshot,
	types,
} from 'mobx-state-tree';

import { deleteBook, getBook, updateBook } from '@common/api/books';
import Group from '@common/models/Groups/Group';
import Program from '@common/models/Programs/Program';

import BookType from './BookType';
import Media from '../Media';

const Book = types
	.model('Book', {
		id: types.identifierNumber,
		name: types.optional(types.string, ''),
		book_type: types.maybeNull(BookType),
		author: types.optional(types.string, ''),
		is_enabled: types.optional(types.boolean, false),
		image_url: types.maybeNull(types.string),
		image: types.maybeNull(Media),
		pdf_url: types.maybeNull(types.string),
		pdf: types.maybeNull(Media),
		programs: types.optional(types.array(Program), []),
		groups: types.optional(types.array(Group), []),
	})
	.volatile(() => ({
		loading: false,
	}))
	.views(() => ({}))
	.actions((self) => ({
		fetch: flow(function* () {
			self.loading = true;
			try {
				const result = yield getBook(self.id);
				applySnapshot(self, result);
			} finally {
				self.loading = false;
			}
		}),
		remove: flow(function* () {
			self.loading = true;
			try {
				yield deleteBook(self.id);
				const parent: any = getParent(self, 2);
				parent.removeItem(self);
			} catch (e) {
				self.loading = false;
			}
		}),
		save: flow(function* (data: any, isGetSnapshot: boolean = true) {
			self.loading = true;
			try {
				const result = yield updateBook(
					self.id,
					isGetSnapshot
						? {
							...getSnapshot(self),
							...data,
						}
						: data,
				);
				applySnapshot(self, result);
			} finally {
				self.loading = false;
			}
		}),
	}));

export default Book;

export interface IBookModel extends Instance<typeof Book> {}
export type IBookSnapshotIn = SnapshotIn<typeof Book>;

export interface IBookWithProgress extends IBookSnapshotIn {
	progress: 'string';
}
